import { render, staticRenderFns } from "./ImagenZoom.vue?vue&type=template&id=184b3046&scoped=true"
import script from "./ImagenZoom.vue?vue&type=script&lang=js"
export * from "./ImagenZoom.vue?vue&type=script&lang=js"
import style0 from "./ImagenZoom.vue?vue&type=style&index=0&id=184b3046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b3046",
  null
  
)

export default component.exports